<button
  [type]="buttonType"
  [ngClass]="['button ', !!styleName ? styleName : '']"
  [style.background-color]="bgColor"
  [style.color]="textColor"
  [style.border]="borderStyle"
  [style.width]="width"
  [style.min-width]="minWidth"
  [style.padding]="padding"
  [style.height]="buttonHeight"
  [style.font-weight]="fontWeight"
  (click)="triggerClickEvent($event)"
  [disabled]="isButtonDisabled"
>
  @if (isIconButton) {
  <span class="inline-flex align-items-center justify-content-center">
    <ng-content></ng-content>
    <span>
      {{ buttonText }}
    </span>
  </span>
  } @else {
  {{ buttonText }}
  }
</button>
